import { LoginReward, LoginRewardStatus } from "@onmo/graphql/graphql";

export const getCurrentDailyReward = (loginRewards: LoginReward[]) => {
  const availableReward = loginRewards?.filter(
    (reward) => reward.claimStatus !== LoginRewardStatus.Unavailable,
  );

  return (availableReward?.length || 0) - 1;
};
